import { render, staticRenderFns } from "./fashionListing.vue?vue&type=template&id=33099daa&scoped=true"
import script from "./fashionListing.vue?vue&type=script&lang=js"
export * from "./fashionListing.vue?vue&type=script&lang=js"
import style0 from "./fashionListing.vue?vue&type=style&index=0&id=33099daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33099daa",
  null
  
)

export default component.exports